import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * SPEC-web-planner-038 AC-1 / AC-3 (R9): the one "Connect your Gmail" block, used by the invite dialogs and the
 * session form. Text is interpolated, never innerHTML. The button goes to Connected accounts. Styled from design
 * tokens only (the fingerprinted design CSS is not touched).
 */
@Component({
    selector: 'app-mailbox-gate',
    templateUrl: './mailbox-gate.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailboxGateComponent {
    @Input() title = 'Connect your Gmail to send invites';
    @Input() message = 'Invites go from your own mailbox, so replies come to you.';
    @Input() actionLabel = 'Connect Gmail';
}
